<!-- 学习服务-图文-我的收藏 -->
<template>
  <div class="wrap">

    <div class="header-wrap">
      <div class="header">
        <img src="@/assets/return.png" class="return-img" @click="$router.back()">
        <p class="header-title">我的收藏</p>
        <button type="button" class="header-btn" @click="swipeCellList.openOrCloseEdit()">
          {{ swipeCellList && swipeCellList.edit ? '取消' : '管理' }}
        </button>
      </div>
    </div>

    <swipe-cell-list ref="swipeCellList" :option="swipeCellOption">
      <template #item="{item}">

        <div class="my-collection-module" @click="toDetail(item)">
          <div class="my-collection-module-top">
            <!-- 失效时候显示 -->
            <div class="my-collection-module-top-img-box" v-if="item.is_normal === 0">
              <img src="@/assets/icon-176.png" class="my-collection-module-top-img" alt="">
            </div>
            <!-- 正常 -->
            <div class="my-collection-module-top-img-box" v-else>
              <file-icon :file-name="item.url" class="my-collection-module-top-img"/>
            </div>
            <div class="my-collection-module-top-sidebar">
              <div class="my-collection-module-top-sidebar-top">
                <p class="my-collection-module-top-sidebar-title">
                  <text-highlight :val="item.title" :highlight-key="swipeCellList.searchKeyword"/>
                </p>
                <p class="my-collection-module-top-sidebar-sub-title">
                  {{ item.recently_title }}
                </p>
              </div>
              <div class="my-collection-module-top-sidebar-bottom">
                <p class="my-collection-module-top-sidebar-row1">
                  <img :src="item.app_logo" class="like-me-top-top-img" v-if="item.app_logo" alt="">
                  <img src="@/assets/avatar.png" class="like-me-top-top-img" v-else alt="">
                  <span>{{ item.app_name || '匿名用户' }}</span>
                </p>
                <p class="my-collection-module-top-sidebar-row2">
                  <img src="@/assets/icon-83.png" alt="">
                  <span>{{ item.read_num }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="my-collection-module-bottom">
            <button :disabled="item.is_normal === 0" type="button" class="my-collection-module-bottom-btn" @click.stop="showShare(item)">
              <img src="@/assets/icon-168.png" alt="">
              {{ item.transmit_num }}
            </button>
            <button :disabled="item.is_normal === 0" type="button" class="my-collection-module-bottom-btn" @click.stop="showCommentPost(item)">
              <img src="@/assets/icon-169.png" alt="">
              {{ item.comment_num }}
            </button>
            <button :disabled="item.is_normal === 0" type="button" class="my-collection-module-bottom-btn" :class="{active: item.is_like}" @click.stop="tags(item)">
              <img src="@/assets/icon-170active.png" alt="" v-if="item.is_like">
              <img src="@/assets/icon-170.png" alt="" v-else>
              {{ item.like_num }}
            </button>
            <button type="button" class="my-collection-module-bottom-btn" :class="{active: item.is_collect}" @click.stop="batchesDel(item.id)">
              <img src="@/assets/icon-172.png" alt="" v-if="item.is_collect">
              <img src="@/assets/icon-171.png" alt="" v-else>
              {{ item.collect_num }}
            </button>
          </div>
        </div>

      </template>
    </swipe-cell-list>

    <comment-post
        ref="commentPost"
        :post-api="option.postApi"
        :post-reply-api="option.postReplyApi"
        @submit="option.submit()"
    />

    <!-- 分享弹窗 -->
    <share-popup ref="sharePopup" type="share" @share="share"/>
  </div>
</template>

<script>
import {
  ArticleService, CollectService, DatumService,
  VideoService
} from "@/common/service";
import VideoTime from "@/components/video-time";
import {
  Toast
} from "vant";
import SwipeCellList from "@/components/swipe-cell-list.vue";
import TextHighlight from "@/components/text-highlight.vue";
import FileIcon from "@/components/file-icon.vue";
import CommentPost from "@/components/comment-post.vue";
import SharePopup from "@/components/share-popup.vue";
import {getFileIcon, getFileType} from "@/common/util";

export default {
  components: {
    SharePopup,
    CommentPost,
    FileIcon,
    TextHighlight,
    SwipeCellList,
    VideoTime
  },
  data() {
    return {
      current: {},

      option: {
        submit: () => {
          if (this.current.id) {
            if (!(/[+.wW]/.test(this.current.comment_num))) {
              this.$set(this.current, 'comment_num', parseInt(this.current.comment_num || 0) + 1);
            }
          }
        },
        // 发布评论
        postApi: params => DatumService.datumComment({
          ...params,
          datum_id: this.current.datum_id,
          url_id: this.current.url_id,
        }),
        // 回复评论
        postReplyApi: (params, comment) => DatumService.secondCommend({
          ...params,
          id: comment.id,
        }),
      },

      swipeCellOption: {
        showSearch: true,
        searchKey: 'title',
        listApi: params => DatumService.getDatumCollect(params),
        itemButtons: [{
          text: '取消收藏',
          bgColor: '#2A63F3',
          click: item => this.batchesDel(item.id),
        }],
        bottomButtons: [{
          text: '取消收藏',
          bgColor: '#2A63F3',
          click: (items = []) => {
            if (items.length === 0) {
              return Toast('请至少选择一个');
            }
            this.batchesDel(items.map(item => item.id).join(','));
          },
        }],
      },
      swipeCellList: null,
    };
  },
  mounted() {
    this.swipeCellList = this.$refs.swipeCellList;
  },
  methods: {
    toDetail(item) {
      if (item.is_normal === 0) return Toast('已下架');
      this.$router.push(`/information-details?id=${item.datum_id}&url_id=${item.url_id}`);
    },

    // 取消收藏
    batchesDel(ids) {
      return DatumService.batchesDel({
        id: ids,
        type: 13,
      }).then(({msg}) => {
        Toast(msg);
        this.swipeCellList.resetList();
        this.swipeCellList.openOrCloseEdit(true);
      });
    },

    // 收藏
    userCollect(info) {
      return DatumService.datumCollect({
        datum_id: info.datum_id,
        url_id: info.url_id,
      }).then(({msg, data}) => {
        Toast(msg);
        this.$set(info, 'is_collect', data.status);
        if (!(/[+.wW]/.test(info.collect_num))) {
          this.$set(info, 'collect_num', parseInt(info.collect_num) + (info.is_collect === 1 ? 1 : -1));
        }
      });
    },

    // 点赞
    tags(info) {
      return DatumService.datumTags({
        datum_id: info.datum_id,
        url_id: info.url_id,
      }).then(({msg, data}) => {
        Toast(msg);
        this.$set(info, 'is_like', data.tags);
        if (!(/[+.wW]/.test(info.like_num))) {
          this.$set(info, 'like_num', parseInt(info.like_num) + (info.is_like === 1 ? 1 : -1));
        }
      });
    },

    /**
     * 显示评论窗
     * @param item
     * @param type post 评论 reply 回复
     */
    showCommentPost(item, type = 'post') {
      if (item.is_normal === 0) return Toast('已下架');
      if (type === 'post') {
        this.current = item;
        this.$refs.commentPost.showFn();
      }
      if (type === 'reply') {
        this.current = {};
        this.$refs.commentPost.showFn(item);
      }
    },

    showShare(item) {
      if (item.is_normal === 0) return Toast('已下架');
      this.current = item;
      const info = this.current;
      let link = `${location.href.split('#')[0]}#/information-details?id=${info.datum_id}&url_id=${info.url_id}`;
      const fileType = getFileType(item.url);
      const fileIcon = getFileIcon(`${fileType}_bg`);
      this.$refs.sharePopup.showFn({
        link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        title: info.title, // 分享标题
        imgUrl: fileIcon.includes('img/') >= 0 ? `${location.href.split('#')[0]}${fileIcon}` : fileIcon, // 分享图标
        desc: info.desc || '', // 分享描述
      });
    },

    share() {
      DatumService.datumTransmit({
        datum_id: this.current.datum_id,
        url_id: this.current.url_id,
      }).then(() => {
        if (!(/[+.wW]/.test(this.current.transmit_num))) {
          this.current.transmit_num = parseInt(this.current.transmit_num) + 1;
        }
      });
    },
  },
}
</script>

<style scoped>
/* 头部样式 */
.header-wrap {
  width: 100%;
  height: 44px;
  /* 	height: 102px; */
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: #FFFFFF;
}

.header-wrap-tab-list-none {
  height: 80px;
  padding-bottom: 10px;
}

.header {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  z-index: 999;
  padding: 0 15px;
  position: relative;
  box-sizing: border-box;
}


.return-img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
  width: 20px;
}

.header-title {
  color: #333333;
  font-size: 18px;
  font-weight:bold;
}
.header-btn {
  color: #222222;
  font-size: 14px;
  position: absolute;
  padding: 0 12px;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.search-box {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;

}

.search-bar {
  flex: 1;
  height: 36px;
  background-color: #FFFFFF;
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}

.search-icon {
  width: 16px;
  margin-right: 8px;
}

.search-input {
  flex: 1;
  font-size: 14px;
}

.search-input::placeholder {
  color: #888888;
}
.tab-list>li {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  color: #555555;
  position: relative;
}

.tab-list>li.active {
  font-size: 18px;
  font-weight:bold;
  color: #222222;
}

.tab-list>li.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background: linear-gradient(90deg, #2A63F3, #81B8FF);
  border-radius: 2px;
  width: 18px;
  height: 4px;
}




.wrap {
  width: 100%;
  height: calc(100vh - 44px);
  display: flex;
  flex-direction: column;
  margin: 44px 0 0;
  box-sizing: border-box;
  background: #F4F4F4;
  overflow-y: auto;
}

.wrap-tab-list-none {
  height: calc(100vh - 90px);
  margin: 90px 0 0;
}


.sub-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  box-sizing: border-box;
  /*height: 100%;*/
  overflow: auto;
}

.sub-list>li {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: 12px;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}


.sub-list>li:last-child {
  margin-bottom: 0;
}

.float-box {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 40px;
  z-index: 499;
}

.float-box>button {
  min-width: 175px;
  height: 44px;
  line-height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2A63F3;
  border-radius: 100px;
  color: #FFFFFF;
  font-size: 18px;
  font-weight:bold;
}

.list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px 15px;
  box-sizing: border-box;
}

.list>li {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  background-color: #FFFFFF;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 12px 10px;
  box-sizing: border-box;
  position: relative;
}

.img-box {
  width: 100px;
  height: 72px;
  position: relative;
  margin-right: 14px;
}

.img {
  width: 100%;
  height: 100%;
  border-radius: 7px;
  object-fit: cover;
}

.tag {
  width: 34px;
  height: 14px;
  line-height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
  border-radius: 0 7px 0 7px;
  color: #222222;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 0;
}

.tag-black {
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.item-sidebar {
  flex: 1;
  height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-name {
  width: 100%;
  line-height: 21px;
  color: #222222;
  font-size: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.row {
  width: 100%;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 12px;
}

.avatar {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 4px;
  object-fit: cover;
}

.row2 {
  width: 100%;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 12px;
}

.play-icon {
  width: 12px;
  margin-right: 4px;
}

.item-between {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.circle-btn {
  width: 13px;
  height: 13px;
}

.circle-icon {
  width: 13px;
}

.normal-box-small {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: #888888;
  padding: 48px 0;
}

.normal-box-small>img {
  width: 195.2px;
  margin-bottom: 38px;
}

.my-collection-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  box-sizing: border-box;
}

.my-collection-list>li {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 10px;
}

.my-circle-box {
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.my-circle-box>img {
  width: 24px;
  height: 24px;
}

.my-collection-module {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0;
}

.my-collection-module-top {
  width: 100%;
  display: flex;
  align-items: center;
}

.my-collection-module-top-img-box {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  margin-right: 10px;
}

.my-collection-module-top-img {
  width: 100%;
  height: 100%;
}

.my-collection-module-top-time {
  background: rgba(0, 0, 0, 0.7);
  height: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  font-size: 9px;
  color: #FFFFFF;
  position: absolute;
  right: 7px;
  bottom: 4px;
}

.my-collection-module-top-time-gray {
  background: rgba(0, 0, 0, 0.3);
  height: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  font-size: 9px;
  color: #FFFFFF;
  position: absolute;
  right: 7px;
  bottom: 3px;
}

.my-collection-module-top-sidebar {
  flex: 1;
  height: 73px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.my-collection-module-top-sidebar-top {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.my-collection-module-top-sidebar-title {
  width: 100%;
  color: #222222;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-sub-title {
  width: 100%;
  color: #222222;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-bottom {
  width: 100%;
  display: flex;
  align-items: center;
}

.my-collection-module-top-sidebar-row1 {
  color: #666666;
  font-size: 10px;
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.my-collection-module-top-sidebar-row1>span {
  max-width: 73px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-row1>img {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 2px;
}

.my-collection-module-top-sidebar-row2 {
  color: #999999;
  font-size: 10px;
  display: flex;
  align-items: center;
}

.my-collection-module-top-sidebar-row2>span {
  /* 	max-width: 45px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical; */
}

.my-collection-module-top-sidebar-row2>img {
  width: 12px;
  margin-right: 2px;
}

.my-collection-module-bottom {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.my-collection-module-bottom-btn {
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 12px;
}

.my-collection-module-bottom-btn.active {
  color: #2A63F3;
}

.my-collection-module-bottom-btn>img {
  width: 16px;
  margin-right: 4px;
}

.footer {
  width: 100%;
  height: 83px;
  box-sizing: border-box;
  padding-top: 8px;
  background-color: #FFFFFF;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
}

.footer-wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}

.footer-all-btn {
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 14px;
}

.footer-all-btn>img {
  width: 24px;
  margin-right: 4px;
}

.cancel-collection-btn {
  background-color: #2A63F3;
  border-radius: 50px;
  width: 100px;
  height: 40px;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
